import React, { useRef, useState } from "react";
import {
    Card,
    Form,
    Row,
    Col,
    Button,
    Spinner
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiUploadCloud } from "react-icons/fi";
import { toast } from "react-toastify";
import { uploadImage } from "../../utils/helpers/fileupload";
import { addGallery } from "../../store/slices/gallery";
import { useNavigate } from "react-router-dom";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";

export default function AddGallery() {

    const token = localStorage.getItem("accessToken");

    const inputRef = useRef(null);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const [dragActive, setDragActive] = useState(false);

    const [formData, setFormData] = useState({
        title: "",
        image: null,
    });

    const [errors, setErrors] = useState({
        title: "",
        image: "",
    });

    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "title":

                if (!value?.trim()) {
                    error = "Please enter title";
                } else if (value.trim().length < 3) {
                    error = "Minimum 3 characters ";
                }
                break;

            case "image":
                if (!value) {
                    error = "Please upload an image";
                }
                break;

            default:
                break;
        }

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));

        return error;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        validateField(name, value);
    };


    const handleFileSelect = (file) => {
        if (!file) return;

        const validTypes = [
            "image/png",
            "image/jpeg",
            "image/jpg",
        ];

        if (!validTypes.includes(file.type)) {
            toast.error("Only PNG, JPG and JPEG files are allowed");
            return;
        }

        setFormData((prev) => ({
            ...prev,
            image: file,
        }));

        validateField("image", file);
    };

    const onChange = (e) => {
        const file = e.target.files[0];
        handleFileSelect(file);
    };

    const onDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const onDragLeave = () => {
        setDragActive(false);
    };

    const onDrop = (e) => {
        e.preventDefault();
        setDragActive(false);

        const file = e.dataTransfer.files[0];
        handleFileSelect(file);
    };


    // Handle submit --- > 
    const handleSubmit = async (e) => {
        e.preventDefault();

        const titleError = validateField(
            "title",
            formData.title
        );

        const imageError = validateField(
            "image",
            formData.image
        );

        if (titleError || imageError) {
            toast.error("Please fix validation errors");
            return;
        }

        try {
            setLoading(true);

            // Upload image
            const imageUrl = await uploadImage(
                formData.image,
                token
            );

            const payload = {
                image: imageUrl,
                title: formData.title.trim(),
            };


            const response = await dispatch(addGallery(payload)).unwrap();

            if (response) {
                toast.success(
                    "Gallery added successfully"
                );

                setFormData({ title: "", image: null, });

                setErrors({ title: "", image: "", });

                if (inputRef.current) {
                    inputRef.current.value = "";
                }
            }

            navigate("/admin/home");
        } catch (error) {
            console.error(error);

            toast.error(
                error?.message ||
                error?.payload?.message ||
                "Failed to add gallery"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap my-2">

                            <Link
                                to="/admin/home"
                                className="breadcrumb-link active"
                            >
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>
                            <Link
                                to="/admin/gallery"
                                className="breadcrumb-link active"
                            >
                                Gallery
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span className="breadcrumb-link inactive">
                                Add Gallery
                            </span>

                        </div>

                    </div>
                </div>
            </div>


            <Card className="global-card border-0 shadow-sm">
                <Card.Body>

                    <Form onSubmit={handleSubmit}>

                        <Row className="g-4">


                            <Col lg={6} md={6} sm={12}>
                                <Form.Group>

                                    <Form.Label className="fw-semibold">
                                        Title

                                    </Form.Label>

                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        className="global-input"
                                        placeholder="Enter title"
                                        maxLength={50}
                                    />

                                    {errors.title && (
                                        <small className="text-danger">
                                            {errors.title}
                                        </small>
                                    )}

                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group className="mb-0">

                                    <label className="fw-semibold mb-2">
                                        Image

                                    </label>



                                    <div
                                        className={` d-flex flex-column justify-content-center align-items-center text-center  rounded-3  
                                            ${dragActive ? "border-primary" : ""
                                            }`}
                                        onDragOver={onDragOver}
                                        onDragLeave={onDragLeave}
                                        onDrop={onDrop}
                                        style={{
                                            border: "2px dashed #7eb3ff", borderRadius: "12px", background: "#eef2f7", minHeight: "220px",
                                            padding: "25px",
                                            transition: "0.3s",
                                        }}
                                    >
                                        {formData.image == null ?
                                            <>
                                                <input
                                                    ref={inputRef}
                                                    type="file"
                                                    hidden
                                                    accept=".png,.jpg,.jpeg"
                                                    onChange={onChange}
                                                />

                                                <div className="mb-3">
                                                    <FiUploadCloud
                                                        size={45}
                                                        color="#3b82f6"
                                                    />
                                                </div>

                                                <Button
                                                    type="button"
                                                    className="px-4"
                                                    onClick={() =>
                                                        inputRef.current?.click()
                                                    }
                                                >
                                                    Browse
                                                </Button>

                                                <p className="mt-3 mb-1 text-secondary">
                                                    drop a file here
                                                </p>

                                                <p className="text-primary small mb-0">
                                                    *File supported .png, .jpg & .jpeg
                                                </p>

                                                {formData.image && (
                                                    <div className="mt-3">
                                                        <strong>
                                                            {formData.image.name}
                                                        </strong>
                                                    </div>
                                                )}
                                            </>


                                            : <>
                                                {formData.image && (
                                                    <Col xs={12} lg={6} className="my-4">
                                                        <div
                                                            className="position-relative d-inline-block"
                                                            style={{
                                                                border: "1px solid #e9ecef", borderRadius: "12px", overflow: "hidden", background: "#fff", padding: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                                                            }}
                                                        >
                                                            <IoCloseCircle
                                                                size={24}
                                                                onClick={() => {
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        image: null,
                                                                    }));

                                                                    if (inputRef.current) {
                                                                        inputRef.current.value = "";
                                                                    }
                                                                }}
                                                                style={{
                                                                    position: "absolute", top: "-1px", right: "-1px", color: "#dc3545", cursor: "pointer", background: "#fff", borderRadius: "50%", zIndex: 10,
                                                                }}
                                                            />

                                                            <img
                                                                src={URL.createObjectURL(formData.image)}
                                                                alt="preview"
                                                                style={{
                                                                    width: "140px", height: "100px", objectFit: "cover", borderRadius: "8px", display: "block",
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                )}
                                            </>}

                                    </div>




                                    {errors.image && (
                                        <small className="text-danger">
                                            {errors.image}
                                        </small>
                                    )}

                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="my-2">
                            {/* Preview -- > */}


                            {/* Submit */}
                            <Col xs={12} className="my-4">
                                <div className="d-flex flex-column justify-content-center flex-sm-row align-items-sm-center gap-3 mt-2 mb-4">
                                    <div className="action-seciton d-flex gap-3">

                                        <button
                                            type="button"
                                            className="global-cancel-btn"
                                            onClick={() => navigate(-1)}
                                            disabled={loading}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="global-submit-btn"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <span className="d-flex align-items-center gap-2">
                                                    <Spinner animation="border" size="sm" />
                                                    Submitting...
                                                </span>
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>

                                    </div>
                                </div>
                            </Col>

                        </Row>

                    </Form>

                </Card.Body>
            </Card>
        </>
    );
}